export default {
  title: {
    id: 'discount_input_subtitle',
    defaultMessage: 'To you: a discount and the good life!',
  },
  flashDeal: {
    id: 'flash_sales_payment_discount_applied',
    defaultMessage: 'Flash deal',
  },
  removeDiscount: {
    id: 'flash_sales_payment_remove_discount',
    defaultMessage: 'Remove discount',
  },
  warning: {
    id: 'flash_sales_payment_discount_warning',
    defaultMessage: 'This cannot be undone',
  },
}
